import { disableScroll, enableScroll } from "./helpers";

document.addEventListener('DOMContentLoaded', () => {
    const header = document.getElementById('wcl-header');
    const button = document.querySelector('.wcl-header .wcl-control');

    if (header && button) {
        button.addEventListener('click', e => {
            e.preventDefault();

            if (header.classList.contains('active')) {
                header.classList.remove('active');

                enableScroll();
            } else {
                header.classList.add('active');

                disableScroll();
            }
        });
    }

    /** Submenu */
    const menuItems = header.querySelectorAll('.menu-item-has-children');

    if (menuItems.length > 0) {
        const isDesktop = window.innerWidth > 1024;

        menuItems.forEach(item => {
            const subMenu = item.querySelector('.sub-menu');
            const subMenuHeight = subMenu.offsetHeight;

            if (isDesktop) {
                item.addEventListener('mouseenter', e => {
                    item.classList.add('active');
                });

                item.addEventListener('mouseleave', e => {
                    item.classList.remove('active');
                });
            } else {
                const menuArrow = item.querySelector('.menu-arrow');

                menuArrow.addEventListener('click', e => {
                    e.preventDefault();
                    e.stopPropagation();

                    if (item.classList.contains('active')) {
                        item.classList.remove('active');
                    } else {
                        item.classList.add('active');
                    }
                });
            }
        });
    }
});